import React, { Component } from 'react';
import {
    Tabs,
    Tab,
    Paper,
    FormControl,
    InputLabel,
    CircularProgress,
    TextField,
    Select,
    MenuItem,
    Button,
    IconButton,
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContentText,
    DialogContent,
    Avatar,
} from '@material-ui/core/';

import T from 'i18n-react';
import Moment from 'moment';

import ReadMesssageIcon from '@material-ui/icons/Drafts';
import UnreadMesssageIcon from '@material-ui/icons/Email';
import CreateEmailIcon from '@material-ui/icons/AddCircleOutline';
import { ImagePicker } from 'react-file-picker';

import { Logger } from '@apricityhealth/web-common-lib'
import { AxiosRequest } from '@apricityhealth/web-common-lib/utils/Axios';
import Config from '@apricityhealth/web-common-lib/Config';
import PatientImage from '@apricityhealth/web-common-lib/components/PatientImage';
import { getErrorMessage } from '@apricityhealth/web-common-lib/utils/getErrorMessage';
import { isArrayValid } from '@apricityhealth/web-common-lib/utils/Services';
import { AttachFile } from '@material-ui/icons';

import DefaultPlaceholderImage from './data/placeholder.jpg';

const MAX_IMAGE_SIZE_MB = 20;
const log = new Logger();
export class MessagesView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messages: [],
            messagesSent: [],
            patientProviders: null,
            selectedProvider: this.props.appContext.state.patient?.primaryProviderId,
            viewState: 'read',
            progress: null,
            messageSubject: '',
            messageBody: '',
            attachments: [],
            inboxOrSent: 0,
            dialog: null,
            attachmentDialog: null
        };
    }

    componentDidMount() {
        this.loadMessages();
    }

    getProviderName(providerId) {
        let name = ''
        const { provider } = ((this.state.patientProviders || []).find((p) => {
            return p.provider && p.provider.providerId === providerId
        }) || {})

        if (provider) {
            if (provider.firstName && provider.lastName) {
                name = provider.firstName + ' ' + provider.lastName
                if (provider.title) {
                    name = provider.title + ' ' + name
                }
                if (provider.suffix) {
                    name += ' ' + provider.suffix;
                }
                if (provider.credentials) {
                    name += ', ' + provider.credentials
                }
            }
        }
        return name
    }


    loadMessages() {
        const { appContext: { state: { patientId, idToken } } } = this.props;

        let getPatientProviders = {
            url: Config.baseUrl + `${Config.pathPrefix}providers/patient/${patientId}?includeOrg=true&inactive=false`,
            method: 'GET',
            headers: { "Authorization": idToken },
        }
        log.debug("getPatientProviders request:", getPatientProviders);
        let getPatientMessages = {
            url: Config.baseUrl + `${Config.pathPrefix}messaging/message/patient/${patientId}?markRead=false`,
            method: 'GET',
            headers: { "Authorization": idToken },
        }
        log.debug("getPatientMessages request:", getPatientMessages);
        let getPatientSentMessages = {
            url: Config.baseUrl + `${Config.pathPrefix}messaging/message/patient/${patientId}?getSent=true`,
            method: 'GET',
            headers: { "Authorization": idToken },
        }
        log.debug("getPatientSentMessages request:", getPatientSentMessages);
        this.setState({ progress: <CircularProgress size={30} /> });
        Promise.all([
            this.state.patientProviders ? this.state.patientProviders : AxiosRequest(getPatientProviders).then((response) => {
                log.debug("getPatientProviders result:", response.data);
                return response.data.providers.filter((e) => e.provider).sort((a, b) => {
                    function validate(prop) {
                        if (a.provider[prop] === undefined) a.provider[prop] = '';
                        if (b.provider[prop] === undefined) b.provider[prop] = '';
                    }
                    validate('title');
                    validate('firstName');
                    validate('lastName');

                    if (a.provider.title !== b.provider.title) return a.provider.title.toLowerCase().localeCompare(b.provider.title.toLowerCase());
                    if (a.provider.firstName !== b.provider.firstName) return a.provider.firstName.toLowerCase().localeCompare(b.provider.firstName.toLowerCase());
                    if (a.provider.lastName !== b.provider.lastName) return a.provider.lastName.toLowerCase().localeCompare(b.provider.lastName.toLowerCase());
                    return 0;
                })
            }),
            AxiosRequest(getPatientMessages).then((response) => {
                log.debug("getPatientMessages result:", response.data);
                return response.data.messages;
            }),
            AxiosRequest(getPatientSentMessages).then((response) => {
                log.debug("getPatientSentMessages result:", response.data);
                return response.data.messages;
            })
        ]).then(([patientProviders, messages, messagesSent]) => {
            this.setState({ progress: null, messages, messagesSent, patientProviders });
        }).catch((err) => {
            log.error("loadContent error:", err);
            this.setState({ progress: null, error: getErrorMessage(err) });
        });
    }

    onProviderSelected(e) {
        this.setState({ selectedProvider: e.target.value })
    }
    onTabSelected(e) {
        let { inboxOrSent } = this.state
        if (inboxOrSent === 0) {
            inboxOrSent = 1
        } else {
            inboxOrSent = 0
        }
        this.setState({ inboxOrSent })
    }

    replyPressed(message) {
        let selectedProvider = ''
        if (message.provider && message.provider.providerId)
            selectedProvider = message.provider.providerId
        let messageSubject = 'Re: ' + message.subject
        const lines = message.message.split('\n').map(line => `> ${line}`);
        const formatted = lines.join('\n');

        this.setState({
            selectedProvider: selectedProvider,
            messageSubject: messageSubject,
            messageBody: `\n\n${formatted}`,
            viewState: 'write',
            dialog: null
        })
    }

    showReplyButton(message) {
        const { patientProviders, progress } = this.state

        //only reply to available providers
        if (message.provider && message.provider.providerId) {
            let providerId = message.provider.providerId
            let provider = (patientProviders || []).find((providerItem) => {
                return providerItem.provider && providerItem.provider.providerId === providerId
            })
            if (provider) {
                return (
                    <Button disabled={progress !== null} color="primary" variant="contained" style={styles.button} onClick={(e) => { this.replyPressed(message); }} ><T.span text="reply"></T.span></Button>
                )
            } else {
                return null
            }
        }
    }

    markAsRead(message) {
        const { inboxOrSent, messages } = this.state
        const { appContext: { state: { idToken } } } = this.props

        //ensure we are in inbox and message read is false
        if (inboxOrSent === 0 && message.read === false) {
            //update local message to reflect read
            messages.forEach((messageItem) => {
                if (messageItem._id === message._id) {
                    messageItem.read = true
                }
            })
            this.setState({ messages, error: null })

            //tell server message has been read
            let markRead = {
                url: Config.baseUrl + `${Config.pathPrefix}messaging/message/${message._id}/updateMessageReadFlag/true`,
                method: 'POST',
                headers: { "Authorization": idToken },
            }
            log.debug("markAsRead request:", markRead);
            AxiosRequest(markRead).then((response) => {
                log.debug("markAsRead result:", response.data);
            }).catch((err) => {
                log.error("markAsRead  error:", err);
                this.setState({error: getErrorMessage(err)})
            })
        }
    }

    deleteMessage(message) {
        const { appContext: { state: { idToken } } } = this.props;

        if (message._id) {
            let deletePatientMessage = {
                url: Config.baseUrl + `${Config.pathPrefix}messaging/message/${message._id}`,
                method: 'DELETE',
                headers: { "Authorization": idToken },
            }

            this.setState({ dialog: null, viewState: 'read', progress: <CircularProgress size={30} /> });
            log.debug("deleteMessage request:", deletePatientMessage);
            AxiosRequest(deletePatientMessage).then((response) => {
                log.debug("deleteMessage response:", response.data);
                this.loadMessages();
            }).catch((err) => {
                log.error("deleteMessage error:", err);
                this.setState({ progress: null, error: getErrorMessage(err) });
            });
        }

    }

    async openAttachment(attachment) {
        const { appContext } = this.props;
        log.info("openAttachment:", attachment);

        this.setState({attachmentDialog: <Dialog open={true} maxWidth='lg' fullScreen={appContext.isCompactDisplay()}>
            <DialogContent>
                <PatientImage appContext={appContext} blobId={attachment.blobId} 
                    size={'100%'} defaultImage={DefaultPlaceholderImage} alt={attachment.name} />
            </DialogContent>
            <DialogActions>
                <Button color='primary' variant='contained' onClick={() => this.setState({attachmentDialog: null})}><T.span text='close' /></Button>
            </DialogActions>
        </Dialog>});
    }

    openMessage(index) {
        const { inboxOrSent, messages, messagesSent, progress } = this.state

        let message = {}
        if (inboxOrSent === 0) {
            message = messages[index];
        } else {
            message = messagesSent[index];
        }
        //mark as read
        const timestamp = Moment(message.createDate).format("MM-DD-YYYY h:mm A")

        let from = ''
        if (message.provider && message.provider.providerId) {
            from = this.getProviderName(message.provider.providerId)
            if (!from) {
                from = message.provider.firstName + ' ' + message.provider.lastName
            }
        }

        let toFrom = <T.span text="From"></T.span>
        if (inboxOrSent === 1) {
            toFrom = <T.span text="To"></T.span>
        }
        this.setState({
            dialog: <div>
                <Dialog
                    model="false"
                    open={true} onClose={() => this.setState({ dialog: null })}
                    fullWidth={true} maxWidth={'xs'} style={{ background: 'rgba(0,0,0,0.6)' }}
                >
                    <DialogTitle style={{ paddingRight: '20px' }}>
                        {message.subject}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ minWidth: 200 }}>
                            <br />
                            {toFrom}: {from}
                            <br />
                            Date: {timestamp}
                            <br />
                            Subject: {message.subject}
                            <br />
                            <br />
                            <span style={{ fontSize: 16, whiteSpace: 'pre-line' }}>{message.message}</span>
                            <br />
                            <br />
                        </DialogContentText>
                        {isArrayValid(message.attachments) && message.attachments.map((attachment) => {
                            return <div>
                                <Button color='primary' variant='contained' style={styles.button} onClick={this.openAttachment.bind(this,attachment)}>
                                    <AttachFile />&nbsp;&nbsp;{attachment.name}
                                </Button>
                            </div>
                        })}
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'space-between', margin: '10px' }}>
                        <Button disabled={progress !== null} color="primary" variant="contained" style={styles.button} onClick={(e) => { this.setState({ dialog: null }); }} ><T.span text="close"></T.span></Button>
                        <Button disabled={progress !== null} color='primary' variant="contained" style={styles.button} onClick={() => this.deleteMessage(message)}><T.span text='delete' /></Button>
                        {this.showReplyButton(message)}
                    </DialogActions>
                </Dialog>
            </div>
        });
        this.markAsRead(message)
    }

    async saveImage(image) {
        try {
            const { appContext } = this.props
            const { patientId, idToken } = appContext.state;

            const headerEnd = image.indexOf(',');
            if ( headerEnd < 0 ) throw new Error("headerEnd not found in image data!");

            const header = image.substr(0, headerEnd).substr(5);              // extact the header and remove the "data:" from the front, 5 characters..
            const contentType = header.substr(0, header.indexOf(';'));        // extract the content type
            const imageData = image.substr(headerEnd + 1);                    // extract the image

            const request = {
                url: Config.baseUrl + `${Config.pathPrefix}images/?patientId=${patientId}`,
                method: 'post',
                data: Buffer.from(imageData, 'base64'),
                type: contentType,
                headers: { "Authorization": idToken, 'Content-Type': contentType },
            };

            log.info("saveImage request:", request);
            const response = await AxiosRequest(request);
            log.info("saveImage response:", response.data );

            return response.data;
        } catch(err) {
            log.error("saveImage error:", err );
            throw err;
        } 
    }

    async sendMessage() {
        try {
            const { selectedProvider, messageSubject, messageBody, attachments } = this.state
            const { appContext } = this.props
            const { patientId, idToken } = appContext.state;

            this.setState({ error: null, progress: <CircularProgress size={20} /> });

            if (isArrayValid(attachments)) {
                await Promise.all(attachments.map(async (attachment) => {
                    try {
                        const { blobId, mimeType } = await this.saveImage(attachment.image);
                        attachment.blobId = blobId;
                        attachment.mimeType = mimeType;
                        delete attachment.image;
                    } catch(err) {
                        log.error("Error saving attachment:", attachment);
                        throw err;
                    }
                }))
            }

            const messageData = {
                patientId: patientId,
                providerId: selectedProvider,
                to: selectedProvider,
                subject: messageSubject,
                message: messageBody,
                attachments
            }

            //{{base_url}}/{{pathPrefix}}messaging/message
            const sendMessage = {
                data: messageData,
                url: Config.baseUrl + `${Config.pathPrefix}messaging/message`,
                method: 'POST',
                headers: { "Authorization": idToken }
            }

            log.debug(`sendMessage request `, sendMessage);
            const response = await AxiosRequest(sendMessage);
            log.debug("sendMessage response:", response.data);

            this.loadMessages()
            this.setState({ attachments: [], messageBody: '', messageSubject: '', viewState: 'read' })
        } catch( err )  {
            log.error("sendMessage error:", err);
            this.setState({ progress: null, error: getErrorMessage(err) });
        }
    }

    onAddAttachment(image) {
        log.debug('onAddAttachment');
        const { attachments } = this.state;
        attachments.push({
            name: '',
            image
        });
        this.setState({ attachments });
    }

    onDeleteAttachment(attachmentIndex) {
        log.debug('onDeleteAttachment:', attachmentIndex );
        const { attachments } = this.state;
        attachments.splice( attachmentIndex, 1 );
        this.setState({ attachments });
    }

    render() {
        const { appContext } = this.props;
        const { patient } = appContext.state;
        const { dialog, attachmentDialog, viewState, messageSubject, messageBody, attachments,
            inboxOrSent, messages, messagesSent, progress, error } = this.state
        const self = this

        const selectProvider = () => {
            const { patientProviders, selectedProvider } = this.state;
            const patientProviderItems = [];

            (patientProviders || []).forEach((providerObj) => {
                let provider = providerObj.provider
                if (provider) {
                    let providerName = this.getProviderName(provider.providerId)
                    patientProviderItems.push(<MenuItem key={provider.providerId} value={provider.providerId}>{providerName}</MenuItem>);
                }
            })

            return (
                <FormControl >
                    <InputLabel><T.span text="to"></T.span>:</InputLabel>
                    <Select
                        style={{ width: 200 }}
                        value={selectedProvider}
                        onChange={self.onProviderSelected.bind(self)}
                    >
                        {patientProviderItems}
                    </Select>
                </FormControl>
            )
        }
        const messagesHeader = () => {
            if (viewState === 'read') {
                return (
                    <div style={styles.inboxHeader}>
                        <Tabs
                            onChange={this.onTabSelected.bind(this)}
                            value={inboxOrSent}
                        >
                            <Tab textColor='#FFFFFF' label={<T.span text="inbox"></T.span>}></Tab>
                            <Tab label={<T.span text="sent"></T.span>}></Tab>
                        </Tabs>
                        <div>{progress}</div>
                        <div>
                            <IconButton disabled={!patient || patient.inactive === true} onClick={() => { this.setState({ viewState: 'write' }) }} >
                                <CreateEmailIcon />
                            </IconButton>
                        </div>
                    </div>
                )
            }
        }

        const getInboxOrSent = () => {
            const emails = []
            if (inboxOrSent === 0) {
                messages.forEach((message, index) => {
                    const timestamp = Moment(message.createDate).format("MM-DD h:mm A")

                    let from = ''
                    if (message.provider) {
                        from = this.getProviderName(message.provider.providerId)
                        if (!from) {
                            from = message.provider.firstName + ' ' + message.provider.lastName
                        }
                    }

                    if (!message.deleted) {
                        emails.push(<Paper key={index} style={styles.message} onClick={() => this.openMessage(index)}>
                            <Grid container wrap="nowrap" direction="row" justifyContent="flex-start">
                                <Grid item style={{ marginRight: 15 }}>
                                    {message.read && <ReadMesssageIcon fontSize='large' style={{ color: 'grey' }} />}
                                    {!message.read && <UnreadMesssageIcon fontSize='large' />}
                                </Grid>
                                <Grid item style={{ textAlign: 'left' }}>
                                    {!message.read && <b><T.span text={{ key: 'inboxMessage', from, subject: message.subject, timestamp }} /></b>}
                                    {message.read && <T.span text={{ key: 'inboxMessage', from, subject: message.subject, timestamp }} />}
                                </Grid>
                            </Grid>
                        </Paper>);
                    }
                })

                return (
                    <div style={styles.inboxSentTable}>
                        {emails}
                    </div>
                )
            } else {
                messagesSent.forEach((message, index) => {
                    const timestamp = Moment(message.createDate).format("MM-DD-YYYY h:mm A");

                    let from = ''
                    if (message.provider) {
                        from = this.getProviderName(message.provider.providerId)
                        if (!from) {
                            from = message.provider.firstName + ' ' + message.provider.lastName
                        }
                    }

                    if (!message.deleted) {
                        emails.push(<Paper key={index} style={styles.message} onClick={() => this.openMessage(index)}>
                            <Grid container wrap="nowrap" direction="row" justifyContent="flex-start">
                                <Grid item style={{ marginRight: 15 }}>
                                    {message.read && <ReadMesssageIcon fontSize='large' style={{ color: 'grey' }} />}
                                    {!message.read && <UnreadMesssageIcon fontSize='large' />}
                                </Grid>
                                <Grid item style={{ textAlign: 'left' }}>
                                    {!message.read && <b><T.span text={{ key: 'sentMessage', from, subject: message.subject, timestamp }} /></b>}
                                    {message.read && <T.span text={{ key: 'sentMessage', from, subject: message.subject, timestamp }} />}
                                </Grid>
                            </Grid>
                        </Paper>);
                    }
                })

                return (
                    <div style={styles.inboxSentTable}>
                        {emails}
                    </div>
                )
            }
        }

        if (viewState === 'read') {
            let icon = React.cloneElement(this.props.icon, { fontSize: 'small', style: { fill: this.props.color } });
            return (
                <Grid id={this.props.id} align="center" className='messages'>
                    <Grid item style={{ width: '100%', marginTop: 15, marginBottom: 15 }}>
                        <Paper style={{ textAlign: 'left', marginLeft: 15, marginRight: 15, marginTop: 5, marginBottom: 5, padding: 15 }} >
                            <div>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item style={{ marginRight: 10 }}>
                                        <Avatar style={{ width: 35, height: 35, border: `2px solid ${this.props.color}`, backgroundColor: 'white' }}>{icon}</Avatar>
                                    </Grid>
                                    <Grid item >
                                        <span style={{ fontSize: 22, fontColor: '#666666' }}>{this.props.label}</span>
                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                    </Grid>
                    {messagesHeader()}
                    {getInboxOrSent()}
                    {dialog}
                    {attachmentDialog}
                    <span style={{color: 'red'}}>{error}</span>
                </Grid>
            )
        } else if (viewState === 'write') {
            // Write Message State
            let icon = React.cloneElement(this.props.icon, { fontSize: 'small', style: { fill: this.props.color } });
            return (
                <Grid id={this.props.id} align="center" className='messages' style={{ marginTop: 15 }}>
                    <Grid item style={{ width: '100%', marginTop: 15, marginBottom: 15 }}>
                        <Paper style={{ textAlign: 'left', marginLeft: 15, marginRight: 15, marginTop: 5, marginBottom: 5, padding: 15 }} >
                            <div>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item style={{ marginRight: 10 }}>
                                        <Avatar style={{ width: 35, height: 35, border: `2px solid ${this.props.color}`, backgroundColor: 'white' }}>{icon}</Avatar>
                                    </Grid>
                                    <Grid item >
                                        <span style={{ fontSize: 22, fontColor: '#666666' }}><T.span text="newMessage" /></span>
                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                    </Grid>
                    <Grid item justifyContent='center' spacing={1}>
                        <Grid item xs={12} sm={12} md={8} lg={8}>
                            <Paper style={styles.composeBody}>
                                <Grid container justifyContent='flex-start' spacing={8} >
                                    <Grid item xs={12}>
                                        {selectProvider()}
                                        <br />
                                        <FormControl >
                                            <InputLabel><T.span text="subject"></T.span>:</InputLabel>
                                            <Select
                                                label="Message Subject"
                                                value={messageSubject}
                                                placeholder="Message Subject"
                                                onChange={(e) => { let subject = e.target.value; self.setState({ messageSubject: subject }) }}
                                                style={{
                                                    minWidth: '200px',
                                                    marginBottom: '10px'
                                                }}
                                            >
                                                <MenuItem
                                                    key={0}
                                                    value={T.translate("messageSubjectAppointment")}
                                                >
                                                    <T.span text="messageSubjectAppointment"></T.span>
                                                </MenuItem>
                                                <MenuItem
                                                    key={1}
                                                    value={T.translate("messageSubjectMedication")}
                                                >
                                                    <T.span text="messageSubjectMedication"></T.span>
                                                </MenuItem>
                                                <MenuItem
                                                    key={2}
                                                    value={T.translate("requestAppointment")}
                                                >
                                                    <T.span text="requestAppointment"></T.span>
                                                </MenuItem>
                                                <MenuItem
                                                    key={3}
                                                    value={T.translate("messageSubjectOther")}
                                                >
                                                    <T.span text="messageSubjectOther"></T.span>
                                                </MenuItem>
                                            </Select>
                                        </FormControl >
                                        <br />

                                        <TextField
                                            id="outlined-multiline-flexible"
                                            label={<T.span text='message'></T.span>}
                                            multiline
                                            fullWidth
                                            rows="6"
                                            style={styles.messageField}
                                            value={messageBody}
                                            onChange={(e) => { let body = e.target.value; self.setState({ messageBody: body }); }}
                                            variant="outlined"
                                        />
                                        <br />
                                        <div style={styles.sendButton}>
                                            <Button disabled={progress !== null} color="primary" variant="contained" style={styles.sendButton}>
                                            <ImagePicker
                                                extensions={['jpg', 'jpeg', 'png', 'webp', 'heic']}
                                                maxSize={1024 * 1024 * MAX_IMAGE_SIZE_MB}
                                                dims={{ minWidth: 100, maxWidth: 8192, minHeight: 100, maxHeight: 8192 }}
                                                onChange={(image) => {
                                                    log.info("onChange:", image);
                                                    attachments.push({ name: `Attachment #${attachments.length + 1}`, image });
                                                    this.setState({ error: null, attachments });
                                                }}
                                                onError={(err) => {
                                                    log.error("onError:", err );
                                                    this.setState({ error: err })
                                                }}>
                                                <T.span text='attach' />
                                            </ImagePicker>
                                            </Button>
                                            <Button disabled={progress !== null} color="primary" variant="contained" style={styles.cancelButton} onClick={() => { self.setState({ viewState: 'read' }) }}><T.span text="cancel"></T.span></Button>
                                            <Button disabled={progress !== null} color="primary" variant="contained" style={styles.sendButton} onClick={self.sendMessage.bind(self)}><T.span text="send"></T.span></Button>
                                        </div>
                                    </Grid>
                                </Grid>
                                <Grid container>
                                {attachments.map((attachment, i) => {
                                    return <Grid item style={{marginTop: 15, marginBottom: 15 }}>
                                        <Paper style={styles.attachment} >
                                            <img src={attachment.image} width={'90%'} alt={attachment.name} />
                                            <div style={{...styles.sendButton, justifyContent: 'space-between' }}>
                                                <Button color='primary' variant='contained' style={styles.cancelButton} onClick={this.onDeleteAttachment.bind(this,i)}><T.span text='remove' /></Button>
                                                <br />
                                                <TextField value={attachment.name} style={{ margin: 15, width: 150}} onChange={(e) => {
                                                    attachment.name = e.target.value;
                                                    this.setState({attachments});
                                                }} />
                                            </div>
                                        </Paper>
                                    </Grid>;
                                })}
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                    <span style={{color: 'red'}}>{error}</span>
                </Grid>
            )

        }

    }

}

const styles = {
    subjectField: {
        width: '100%'
    },
    inboxSentTable: {
        margin: 20
    },
    cellItems: {
        paddingLeft: 5,
        paddingRight: 5
    },
    newMessage: {
        textAlign: 'left',
        marginLeft: 20
    },
    inboxHeader: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 20
    },
    composeHeader: {
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 20
    },
    attachment: {
        //display: 'flex',
        align: 'center',
        justifyContent: 'center',
        margin: 20,
        padding: 20
    },
    composeBody: {
        textAlign: 'left',
        justifyContent: 'flex-end',
        margin: 20,
        padding: 20
    },
    sendButton: {
        marginTop: 10,
        display: 'flex',
        justifyContent: 'space-between'
    },
    cancelButton: {
        marginTop: 10,
        marginRight: 10
    },
    deleteButton: {
        position: 'absolute',
        right: 10,
        top: 10
    },
    message: {
        margin: 5,
        padding: 5,
        cursor: 'pointer'
    },
    button: {
        margin: 5,
    },
    centeredDiv: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
    },
    centeredFlex: {
       display: 'flex',
       alignItems: 'flex-start',
       justifyContent: 'flex-start',
       flexWrap: 'wrap',
    }
} 